"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_RETRIES = exports.RETRY_INTERVAL = exports.TOKEN_REFRESH_MARGIN = exports.COOKIE_OPTIONS = void 0;
exports.COOKIE_OPTIONS = {
    name: 'sb',
    lifetime: 7 * 24 * 60 * 60,
    domain: '',
    path: '/',
    sameSite: 'lax'
};
exports.TOKEN_REFRESH_MARGIN = 10; // in seconds
exports.RETRY_INTERVAL = 2; // in hundred ms (initial retry after 200ms with exponential backoff)
exports.MAX_RETRIES = 10;
//# sourceMappingURL=constants.js.map